// extracted by mini-css-extract-plugin
export default {"inputWrapper":"betInput_inputWrapper__yaGrL","label":"betInput_label__GUs5Y"};